import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Decription from "components/features/TwoColDescriptionProducts";

// Import images
import manualImages from "assets/manual_downloads.png";

// Table styled components
const TableContainer = styled.div`
  ${tw`overflow-x-auto shadow-lg rounded-lg`}
`;

const Table = styled.table`
  ${tw`min-w-full bg-white`}
`;

const TableHeader = styled.thead`
  ${tw`bg-gradient-to-r from-blue-500 to-blue-600 text-white`}
`;

const TableHeaderCell = styled.th`
  ${tw`px-6 py-4 text-left text-sm font-semibold uppercase tracking-wider`}
`;

const TableBody = styled.tbody`
  ${tw`divide-y divide-gray-200`}
`;

const TableRow = styled.tr`
  ${tw`hover:bg-gray-100 transition-colors duration-200`}
`;

const TableCell = styled.td`
  ${tw`px-6 py-4 whitespace-nowrap`}
`;

const ManualName = styled.div`
  ${tw`text-sm font-medium text-gray-900`}
`;

const DownloadButton = styled.button`
  ${tw`inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200`}
`;

const ManualImage = styled.img`
  ${tw`h-12 w-12 rounded-lg object-cover`}
`;

export default () => {

    // Sample data for manuals - replace with your actual data
    const manualsData = [
        {
            id: 1,
            manual: "Manual Sensor de Temperatura UCv1",
            downloadUrl: "/te_ucv1.pdf",
            imageAlt: "Sensor de temperatura UCv1'"
        },
        {
            id: 2,
            manual: "Manual Sensor de Nível UCv1",
            downloadUrl: "/vl_ucv1.pdf",
            imageAlt: "Sensor de Nível UCv1"
        }
    ];

    const handleDownload = (url, filename) => {
        // Create a temporary link element and trigger download
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
    };

    const content = (
        <TableContainer>
            <Table>
                <TableHeader>
                    <tr>
                        <TableHeaderCell>Equipamentos</TableHeaderCell>
                        <TableHeaderCell>Manual</TableHeaderCell>
                    </tr>
                </TableHeader>
                <TableBody>
                    {manualsData.map((manual) => (
                        <TableRow key={manual.id}>
                            <TableCell>
                                <ManualName>{manual.manual}</ManualName>
                            </TableCell>
                            <TableCell>
                                <DownloadButton
                                    onClick={() => handleDownload(manual.downloadUrl, manual.manual)}
                                >
                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    Baixar Manual
                                </DownloadButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
    return (
        <>
            <Decription
                imageSrc={[manualImages]}
                imageBorder={false}
                imageShadow={false}
                imageDecoratorBlob={true}
                description={[]}
                descriptionRight={[
                    "",
                ]}
                content={content}
                columns60x40={true}
                heading="Manuais de Equipamentos mTs"
            />
        </>
    );
}
